import SignUpRoutes from './views/SignUp/router';
import Auth from './AuthView';

export default [
  {
    path: '/',
    redirect: '/signup',
    component: Auth,
    children: [
      ...SignUpRoutes,
    ],
  },
];
